module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/index/icon01-0fc2273d22aa2b02314f5cb55a69bab3.png";